import Vue from 'vue'
import Router from 'vue-router'

import Login from '../views/Login.vue'
import UserPage from '../views/UserPage.vue'
import Dashboard from '../views/Dashboard.vue'
import Unit from '../views/Unit.vue'
import Operator from '../views/Operator.vue'
import News from '../views/News.vue'
import Question from '../views/Question.vue'
import UnitView from '../views/UnitView.vue'

import { localStore } from '@/_utils/localstore'

Vue.use(Router)

export const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '',
      component: UserPage,
      children: [
        {
          path: '',
          name: '',
          component: Dashboard,
          children: [
            {
              path: '',
              name: 'home',
              component: Unit
            },
          ],
        },
        {
          path: 'dashboard',
          component: Dashboard,
          children: [
            {
              path: '',
              name: 'dashboard',
              component: Unit
            },
            {
              path: 'unit',
              name: 'unit',
              component: Unit,
            },
            {
              path: 'unit/:unit_id',
              name: 'unit_detail',
              component: UnitView
            },
            {
              path: 'operator',
              name: 'operator',
              component: Operator
            },
            {
              path: 'news',
              name: 'news',
              component: News
            },
            {
              path: 'question',
              name: 'question',
              component: Question
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    { path: '*', redirect: '/dashboard' }
  ],
  linkActiveClass: 'is-active'
})

router.beforeEach(
  (to: any, from: any, next: any): any => {
    const publicPages = ['/login']
    const authRequired = !publicPages.includes(to.path)
    const loggedIn = localStore.getItem('user')

    if (authRequired && !loggedIn) {
      return next('/login')
    }

    next()
  }
)
